module.exports = __webpack_public_path__ + "img/cttotherdest-icon.30b91c0a.png";